import { useEffect } from "react";
import UserDisplayComponent from "../../Components/Users/UserDisplayComponent";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import Navbar from "../../_Layouts/Navbar/Navbar";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";
import { findUserBySocieteIdApi } from "../../_App/Redux/Slices/users/userSlice";
const UserItemPage = () => {
  const societe=useAppSelector(societeId)
  const dispatch=useAppDispatch()
    useEffect(() => {
      if (societe) {
        dispatch(findUserBySocieteIdApi(societe));
      }
    }, []);
  return (
    <>
      <Navbar  />
    <div>
      <UserDisplayComponent />
    </div>
    </>
  );
};

export default UserItemPage;
